import {featureFlags} from '@dms/feature-flags';
import {warehouseRoutes} from '@dms/routes';

export type WarehouseChartTab = {
  /**
   * Slug shared by the module item ids and by the legacy
   * `/warehouses/reporting/<slug>` redirects.
   */
  id: string;
  path: string;
  featureFlag: string;
};

/**
 * Single source of truth for the warehouse reporting charts.
 *
 * The chart route items in `WarehouseModule` are deliberately written out literally instead
 * of being generated from this list: the DMS route-catalog generator is a TypeScript AST
 * walker that only resolves a literal string `id` together with a direct
 * `warehouseRoutes.<member>` path reference. Anything built inside a `map`/`flatMap` is
 * invisible to it and the AI assistant then cannot deep-link to the route.
 *
 * Use this constant for the feature-flag predicates and for the unavailable-chart fallbacks,
 * never for generating the route items themselves.
 */
export const WAREHOUSE_CHART_TABS: WarehouseChartTab[] = [
  {
    id: 'inventory-value',
    path: warehouseRoutes.reportingChartInventory,
    featureFlag: featureFlags.ADVANCED_WAREHOUSE_INVENTORY_VALUE_REPORTING,
  },
  {
    id: 'dead-stock',
    path: warehouseRoutes.reportingChartDeadStock,
    featureFlag: featureFlags.ADVANCED_WAREHOUSE_DEAD_STOCK_REPORTING,
  },
  {
    id: 'warehouse-movements',
    path: warehouseRoutes.reportingChartMovements,
    featureFlag: featureFlags.ADVANCED_WAREHOUSE_MOVEMENTS_REPORTING,
  },
  {
    id: 'direct-sales-performance',
    path: warehouseRoutes.reportingChartDirectSales,
    featureFlag: featureFlags.ADVANCED_WAREHOUSE_DIRECT_SALES_REPORTING,
  },
];
